export default __webpack_public_path__ + "static/media/gameplayBg2.d35dc6e3.png";